import { useTranslation } from 'react-i18next';

import { MessageReadMarker } from './MessageReadMarker';

type Props = {
  index: number;
};

const ConversationArchivedMessage = ({ index }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      data-message-index={index}
      className="flex items-center m-8 scroll-mb-8 relative font-thin text-sm gap-1"
    >
      &mdash;
      <span className="text-[#575757]">{t('conversation_archived')}</span>
      &mdash;
      <MessageReadMarker index={index} />
    </div>
  );
};

export default ConversationArchivedMessage;
